import { Navigate, Route, Routes, useParams } from "react-router-dom";
import {
  AboutUs,
  AdvertiseWithUs,
  AfterIntermediateHub,
  AfterIntermediateNext,
  AfterIntermediateStream,
  BTech,
  BtechDistrictWise,
  CollegeDetails,
  CollegesDegree,
  ContactUs,
  CourseGuide,
  CseVsAiml,
  DegreeCollegeDetails,
  DisclaimerPage,
  DistrictLandingHub,
  DistrictStreamLanding,
  Eamcet,
  EamcetBipcSyllabus,
  EamcetNotification,
  EamcetDeadlineUpdate,
  EamcetResults,
  EamcetSyllabus,
  FAQIndex,
  HelpPage,
  Home,
  ImportantQuestions,
  IntermediateQuestionsHub,
  IntermediateSubjectPage,
  IntermediateYearPage,
  IntermediateUnitPage,
  IntermediateColleges,
  IntermediateCollegeDetails,
  IntermediateFirstYearResults,
  IntermediateResults,
  IntermediateExpectedResults,
  IntermediateSecondYearResults,
  KnowledgeIndex,
  KnowledgePage,
  JntuhSyllabus,
  JntuhMatricesQuestions,
  JntuhWaterTreatmentQuestions,
  JntuhChemistryUnit2,
  JntuhBEEUnit1,
  NotFound,
  Pharmacy,
  PharmacyCollegeDetails,
  PrivacyPolicy,
  Results,
  SearchResults,
  SchoolTopPicks,
  SchoolsDirectory,
  SscResults,
  SscExamTomorrow,
  AndhraSchoolDetails,
  TermsConditions,
  Top10Affordable,
  Top10BtechColleges,
  Top10BiPC,
  Top10CEC,
  Top10Degree,
  Top10DegreeBA,
  Top10DegreeBBA,
  Top10DegreeBCom,
  Top10DegreeBSc,
  Top10EAMCET,
  Top10Hostel,
  Top10IITJEE,
  Top10MEC,
  Top10MPC,
  Top10Navigation,
  WhyAiml,
  WhyBA,
  WhyBBA,
  WhyBCA,
  WhyBCom,
  WhyBIPC,
  WhyBSc,
  WhyBTech,
  WhyCEC,
  WhyCivil,
  WhyCSE,
  WhyDataScience,
  WhyECE,
  WhyEEE,
  WhyHEC,
  WhyIT,
  WhyMechanical,
  WhyMEC,
  WhyMPC,
} from "./lazyPages";

const SchoolsDistrictRoute = ({ mode }) => {
  const { districtSlug } = useParams();
  return <SchoolsDirectory mode={mode} districtSlug={districtSlug} />;
};

const SchoolTopPicksLegacyRedirect = () => {
  const { boardType } = useParams();
  return <Navigate to={`/schools/top-schools/${boardType || "all-boards"}`} replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/intermediate/colleges" element={<IntermediateColleges />} />
    <Route path="/intermediate/colleges/:slug" element={<IntermediateCollegeDetails />} />
    <Route path="/intermediate/colleges/andhra-pradesh" element={<DistrictLandingHub />} />
    <Route path="/intermediate/colleges/andhra-pradesh/:districtSlug" element={<DistrictStreamLanding />} />
    <Route path="/intermediate/colleges/andhra-pradesh/:districtSlug/girls-colleges" element={<DistrictStreamLanding />} />
    <Route path="/intermediate/colleges/andhra-pradesh/:districtSlug/:streamSlug" element={<DistrictStreamLanding />} />
    <Route path="/intermediate/colleges/andhra-pradesh/:districtSlug/:streamSlug/girls-colleges" element={<DistrictStreamLanding />} />
    <Route path="/colleges/btech" element={<BTech />} />
    <Route path="/colleges/btech/:slug" element={<CollegeDetails />} />
    <Route path="/colleges/btech/district-wise" element={<BtechDistrictWise />} />
    <Route path="/colleges/pharmacy" element={<Pharmacy />} />
    <Route path="/colleges/pharmacy/:slug" element={<PharmacyCollegeDetails />} />
    <Route path="/colleges/degree" element={<CollegesDegree />} />
    <Route path="/colleges/degree/:slug" element={<DegreeCollegeDetails />} />
    <Route path="/schools" element={<SchoolsDirectory mode="all" />} />
    <Route path="/schools/all" element={<Navigate to="/schools" replace />} />
    <Route path="/schools/andhra-pradesh" element={<Navigate to="/schools" replace />} />
    <Route path="/schools/district/:districtSlug" element={<SchoolsDistrictRoute mode="all" />} />
    <Route path="/schools/ssc" element={<SchoolsDirectory mode="ssc" />} />
    <Route path="/schools/ssc/district/:districtSlug" element={<SchoolsDistrictRoute mode="ssc" />} />
    <Route path="/schools/cbse" element={<SchoolsDirectory mode="cbse" />} />
    <Route path="/schools/cbse/district/:districtSlug" element={<SchoolsDistrictRoute mode="cbse" />} />
    <Route path="/schools/cisce" element={<SchoolsDirectory mode="cisce" />} />
    <Route path="/schools/cisce/district/:districtSlug" element={<SchoolsDistrictRoute mode="cisce" />} />
    <Route path="/schools/top-schools" element={<Navigate to="/schools/top-schools/all-boards" replace />} />
    <Route path="/schools/top-schools/:boardType" element={<SchoolTopPicks />} />
    <Route path="/schools/top-picks" element={<Navigate to="/schools/top-schools/all-boards" replace />} />
    <Route path="/schools/top-picks/:boardType" element={<SchoolTopPicksLegacyRedirect />} />
    <Route path="/schools/:boardKey/:schoolSlug" element={<AndhraSchoolDetails />} />
    <Route path="/schools/andhra-pradesh/:schoolId" element={<AndhraSchoolDetails />} />
    <Route path="/eamcet" element={<Eamcet />} />
    <Route path="/engineering-syllabus" element={<JntuhSyllabus />} />
    <Route
      path="/engineering-important-questions/water-and-its-treatment"
      element={<JntuhWaterTreatmentQuestions />}
    />
    <Route
      path="/engineering-important-questions/matrices-and-calculus-unit-1"
      element={<JntuhMatricesQuestions />}
    />
    <Route
      path="/engineering-important-questions/chemistry-unit-2"
      element={<JntuhChemistryUnit2 />}
    />
    <Route
      path="/engineering-important-questions/bee-unit-1"
      element={<JntuhBEEUnit1 />}
    />
    <Route path="/eamcet/important-questions" element={<ImportantQuestions />} />
    <Route path="/intermediate-important-questions" element={<IntermediateQuestionsHub />} />
    <Route path="/intermediate-important-questions/:subjectSlug" element={<IntermediateSubjectPage />} />
    <Route path="/intermediate-important-questions/:subjectSlug/:yearSlug" element={<IntermediateYearPage />} />
    <Route path="/intermediate-important-questions/:subjectSlug/:yearSlug/:unitSlug" element={<IntermediateUnitPage />} />
    <Route path="/results" element={<Results />} />
    <Route path="/results/ssc" element={<SscResults />} />
    <Route path="/results/ssc-exam-tomorrow" element={<SscExamTomorrow />} />
    <Route path="/results/intermediate" element={<IntermediateResults />} />
    <Route path="/results/intermediate-expected-2026" element={<IntermediateExpectedResults />} />
    <Route path="/results/intermediate-1st-year" element={<IntermediateFirstYearResults />} />
    <Route path="/results/intermediate-2nd-year" element={<IntermediateSecondYearResults />} />
    <Route path="/eamcet-timetable" element={<EamcetResults />} />
    <Route path="/eamcet-notification-2026" element={<EamcetNotification />} />
    <Route path="/eamcet-application-deadline-2026" element={<EamcetDeadlineUpdate />} />
    <Route path="/eamcet-syllabus-2026" element={<EamcetSyllabus />} />
    <Route path="/eamcet-mpc-syllabus-2026" element={<EamcetSyllabus />} />
    <Route path="/eamcet-bipc-syllabus-2026" element={<EamcetBipcSyllabus />} />
    <Route path="/top-10" element={<Top10Navigation />} />
    <Route path="/top-10/mpc-colleges" element={<Top10MPC />} />
    <Route path="/top-10/bipc-colleges" element={<Top10BiPC />} />
    <Route path="/top-10/cec-colleges" element={<Top10CEC />} />
    <Route path="/top-10/mec-colleges" element={<Top10MEC />} />
    <Route path="/top-10/affordable-colleges" element={<Top10Affordable />} />
    <Route path="/top-10/iit-jee-colleges" element={<Top10IITJEE />} />
    <Route path="/top-10/eamcet-colleges" element={<Top10EAMCET />} />
    <Route path="/top-10/hostel-colleges" element={<Top10Hostel />} />
    <Route path="/top-10/degree-colleges" element={<Top10Degree />} />
    <Route path="/top-10/degree-bba-colleges" element={<Top10DegreeBBA />} />
    <Route path="/top-10/degree-bcom-colleges" element={<Top10DegreeBCom />} />
    <Route path="/top-10/degree-bsc-colleges" element={<Top10DegreeBSc />} />
    <Route path="/top-10/degree-ba-colleges" element={<Top10DegreeBA />} />
    <Route path="/top-10/engineering-colleges" element={<Top10BtechColleges />} />
    <Route path="/why-mpc" element={<WhyMPC />} />
    <Route path="/why-bipc" element={<WhyBIPC />} />
    <Route path="/why-cec" element={<WhyCEC />} />
    <Route path="/why-mec" element={<WhyMEC />} />
    <Route path="/why-hec" element={<WhyHEC />} />
    <Route path="/why-bba" element={<WhyBBA />} />
    <Route path="/why-bcom" element={<WhyBCom />} />
    <Route path="/why-bsc" element={<WhyBSc />} />
    <Route path="/why-ba" element={<WhyBA />} />
    <Route path="/why-bca" element={<WhyBCA />} />
    <Route path="/why-btech" element={<WhyBTech />} />
    <Route path="/why-cse" element={<WhyCSE />} />
    <Route path="/why-civil" element={<WhyCivil />} />
    <Route path="/why-mechanical" element={<WhyMechanical />} />
    <Route path="/why-ece" element={<WhyECE />} />
    <Route path="/why-eee" element={<WhyEEE />} />
    <Route path="/why-it" element={<WhyIT />} />
    <Route path="/why-aiml" element={<WhyAiml />} />
    <Route path="/why-data-science" element={<WhyDataScience />} />
    <Route path="/cse-vs-cse-aiml" element={<CseVsAiml />} />
    <Route path="/after-intermediate" element={<AfterIntermediateHub />} />
    <Route path="/after-intermediate-next" element={<AfterIntermediateNext />} />
    <Route path="/after-intermediate/:slug" element={<AfterIntermediateStream />} />
    <Route path="/courses/:courseSlug" element={<CourseGuide />} />
    <Route path="/guides" element={<KnowledgeIndex />} />
    <Route path="/faq" element={<FAQIndex />} />
    <Route path="/search" element={<SearchResults />} />
    <Route path="/guides/:slug" element={<KnowledgePage />} />
    <Route path="/faq/:slug" element={<KnowledgePage />} />
    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/help" element={<HelpPage />} />
    <Route path="/disclaimer" element={<DisclaimerPage />} />
    <Route path="/advertise-with-us" element={<AdvertiseWithUs />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-conditions" element={<TermsConditions />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
